import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'perfect-scrollbar';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';

import withStyles from '@material-ui/core/styles/withStyles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import PersonIcon from '@material-ui/icons/Person';
import StarIcon from '@material-ui/icons/StarBorder';

// import HeaderLinks from '../Header/HeaderLinks';
import { getAbility, getLoggedUserFirstName } from '../../reducers/sessionReducer';
import sidebarStyle from '../../assets/jss/material-dashboard-pro-react/components/sidebarStyle';
import authActions from '../../actions/authActions';

let ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {

  componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
    }
  }

  render() {
    const { className, user, headerLinks, links } = this.props;
    return (
      <div className={className} ref="sidebarWrapper">
        {user}
        {headerLinks}
        {links}
      </div>
    );
  }
}

class Sidebar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute('/components'),
      openForms: this.activeRoute('/forms'),
      openTables: this.activeRoute('/tables'),
      openMaps: this.activeRoute('/maps'),
      openPages: this.activeRoute('-page'),
      miniActive: true,
    };
    this.activeRoute.bind(this);
  }

  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1;
  }

  openCollapse(collapse) {
    const st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }

  isRouteNonRenderable = (route) => {
    const { ability } = this.props;
    const { redirect, hidden, permission } = route;
    const condition = (
      redirect
      || hidden
      || (permission && !ability.can(permission.action, permission.subject))
    );
    return condition;
  };

  isCollapsedRouteNonRenderable = (route) => {
    let answer = true;
    route.views.forEach((view) => {
      if (!this.isRouteNonRenderable(view)) {
        answer = false;
      }
    });
    return answer;
  };

  getMyProfilePath = () => '/my-profile-edition';

  logout = () => this.props.dispatch(authActions.logout());

  render() {
    const {
      classes,
      color,
      logo,
      image,
      logoText,
      routes,
      bgColor,
      rtlActive,
    } = this.props;
    const itemText = `${classes.itemText
    } ${
      cx({
        [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
        [classes.itemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.itemTextRTL]: rtlActive,
      })}`;
    const collapseItemText = `${classes.collapseItemText
    } ${
      cx({
        [classes.collapseItemTextMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.collapseItemTextRTL]: rtlActive,
      })}`;
    const userWrapperClass = `${classes.user
    } ${
      cx({
        [classes.whiteAfter]: bgColor === 'white',
      })}`;
    const caret = `${classes.caret
    } ${
      cx({
        [classes.caretRTL]: rtlActive,
      })}`;
    const collapseItemMini = `${classes.collapseItemMini
    } ${
      cx({
        [classes.collapseItemMiniRTL]: rtlActive,
      })}`;
    const photo = `${classes.photo
    } ${
      cx({
        [classes.photoRTL]: rtlActive,
      })}`;
    const user = (
      <div className={userWrapperClass}>
        <div className={photo}>
          <PersonIcon className={classes.avatarImg} />
        </div>
        <List className={classes.list}>
          <ListItem className={`${classes.item} ${classes.userItem}`}>
            <NavLink
              to="#"
              className={`${classes.itemLink} ${classes.userCollapseButton}`}
              onClick={() => this.openCollapse('openAvatar')}
            >
              <ListItemText
                primary={this.props.userName}
                secondary={(
                  <b
                    className={
                      `${caret} ${classes.userCaret 
                      } ${ 
                        this.state.openAvatar ? classes.caretActive : ''}`
                    }
                  />
                )}
                disableTypography
                className={`${itemText} ${classes.userItemText}`}
              />
            </NavLink>
            <Collapse in={this.state.openAvatar} unmountOnExit>
              <List className={`${classes.list} ${classes.collapseList} ${classes.userCollapseList}`}>
                <ListItem className={classes.collapseItem}>
                  <NavLink
                    to={this.getMyProfilePath()}
                    className={
                      `${classes.itemLink} ${classes.userCollapseLinks}`
                    }
                  >
                    <StarIcon className={collapseItemMini} nativeColor="#ccc" />
                    <ListItemText
                      primary="Meu perfil"
                      disableTypography
                      className={`${collapseItemText} ${classes.userCollapseItemText}`}
                    />
                  </NavLink>
                </ListItem>
                <ListItem className={classes.collapseItem}>
                  <NavLink
                    to="#"
                    onClick={this.logout}
                    className={
                      `${classes.itemLink} ${classes.userCollapseLinks}`
                    }
                  >
                    <StarIcon className={collapseItemMini} nativeColor="#ccc" />
                    <ListItemText
                      primary="Sair"
                      disableTypography
                      className={`${collapseItemText} ${classes.userCollapseItemText}`}
                    />
                  </NavLink>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </List>
      </div>
    );
    const links = (
      <List className={classes.list}>
        {routes.map((prop, key) => {
          if (this.isRouteNonRenderable(prop)) {
            return null;
          }
          if (prop.collapse) {
            if (this.isCollapsedRouteNonRenderable(prop)) {
              return null;
            }
            const navLinkClasses = `${classes.itemLink
            } ${
              cx({
                [` ${classes.collapseActive}`]: this.activeRoute(prop.path),
              })}`;
            const itemText = `${classes.itemText
            } ${
              cx({
                [classes.itemTextMini]:
                  this.props.miniActive && this.state.miniActive,
                [classes.itemTextMiniRTL]:
                  rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.itemTextRTL]: rtlActive,
              })}`;
            const collapseItemText = `${classes.collapseItemText
            } ${
              cx({
                [classes.collapseItemTextMini]:
                  this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextMiniRTL]:
                  rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextRTL]: rtlActive,
              })}`;
            const itemIcon = `${classes.itemIcon
            } ${
              cx({
                [classes.itemIconRTL]: rtlActive,
              })}`;
            const caret = `${classes.caret
            } ${
              cx({
                [classes.caretRTL]: rtlActive,
              })}`;
            return (
              <ListItem key={key} className={classes.item}>
                <NavLink
                  to="#"
                  className={navLinkClasses}
                  onClick={() => this.openCollapse(prop.state)}
                >
                  <ListItemIcon className={itemIcon}>
                    <prop.icon />
                  </ListItemIcon>
                  <ListItemText
                    primary={prop.name}
                    secondary={(
                      <b
                        className={
                          `${caret 
                          } ${ 
                            this.state[prop.state] ? classes.caretActive : ''}`
                        }
                      />
                    )}
                    disableTypography
                    className={itemText}
                  />
                </NavLink>
                <Collapse in={this.state[prop.state]} unmountOnExit>
                  <List className={`${classes.list} ${classes.collapseList}`}>
                    {prop.views.map((prop, key) => {
                      if (this.isRouteNonRenderable(prop)) {
                        return null;
                      }
                      const navLinkClasses = `${classes.collapseItemLink
                      } ${
                        cx({
                          [` ${classes[color]}`]: this.activeRoute(prop.path),
                        })}`;
                      const collapseItemMini = `${classes.collapseItemMini
                      } ${
                        cx({
                          [classes.collapseItemMiniRTL]: rtlActive,
                        })}`;
                      return (
                        <ListItem key={key} className={classes.collapseItem}>
                          <NavLink to={prop.path} className={navLinkClasses}>
                            <span className={collapseItemMini}>
                              {prop.mini}
                            </span>
                            <ListItemText
                              primary={prop.name}
                              disableTypography
                              className={collapseItemText}
                            />
                          </NavLink>
                        </ListItem>
                      );
                    })}
                  </List>
                </Collapse>
              </ListItem>
            );
          }
          const navLinkClasses = `${classes.itemLink
          } ${
            cx({
              [` ${classes[color]}`]: this.activeRoute(prop.path),
            })}`;
          const itemText = `${classes.itemText
          } ${
            cx({
              [classes.itemTextMini]:
                this.props.miniActive && this.state.miniActive,
              [classes.itemTextMiniRTL]:
                rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.itemTextRTL]: rtlActive,
            })}`;
          const itemIcon = `${classes.itemIcon
          } ${
            cx({
              [classes.itemIconRTL]: rtlActive,
            })}`;
          return (
            <ListItem key={key} className={classes.item}>
              <NavLink to={prop.path} className={navLinkClasses}>
                <ListItemIcon className={itemIcon}>
                  <prop.icon />
                </ListItemIcon>
                <ListItemText
                  primary={prop.name}
                  disableTypography
                  className={itemText}
                />
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    );

    const logoNormal = `${classes.logoNormal
    } ${
      cx({
        [classes.logoNormalSidebarMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.logoNormalSidebarMiniRTL]:
          rtlActive && this.props.miniActive && this.state.miniActive,
        [classes.logoNormalRTL]: rtlActive,
      })}`;
    const logoMini = `${classes.logoMini
    } ${
      cx({
        [classes.logoMiniRTL]: rtlActive,
      })}`;
    const logoClasses = `${classes.logo
    } ${
      cx({
        [classes.whiteAfter]: bgColor === 'white',
      })}`;
    const brand = (
      <div className={logoClasses}>
        <a href="https://www.confiancaplanejamento.com/" className={logoMini}>
          <img src={logo} alt="logo" className={classes.img} />
        </a>
        <a href="https://www.confiancaplanejamento.com/" className={logoNormal}>
          {logoText}
        </a>
      </div>
    );
    const drawerPaper = `${classes.drawerPaper
    } ${
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.drawerPaperRTL]: rtlActive,
      })}`;
    const sidebarWrapper = `${classes.sidebarWrapper
    } ${
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]:
          navigator.platform.indexOf('Win') > -1,
      })}`;
    return (
      <div ref="mainPanel">
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={rtlActive ? 'left' : 'right'}
            open={this.props.open}
            classes={{
              paper: `${drawerPaper} ${classes[`${bgColor}Background`]}`,
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={user}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: `url(${image})` }}
              />
            ) : null}
          </Drawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={rtlActive ? 'right' : 'left'}
            variant="permanent"
            open
            classes={{
              paper: `${drawerPaper} ${classes[`${bgColor}Background`]}`,
            }}
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              user={user}
              links={links}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: `url(${image})` }}
              />
            ) : null}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(['white', 'black', 'blue']),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf(['white', 'red', 'orange', 'green', 'blue', 'purple', 'rose']),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  dispatch: PropTypes.func.isRequired,
  ability: PropTypes.object.isRequired,
  userName: PropTypes.string.isRequired,
};

Sidebar.defaultProps = {
  bgColor: 'blue',
};

const mapStateToProps = state => ({
  ability: getAbility(state),
  userName: getLoggedUserFirstName(state),
});

export default connect(mapStateToProps)(withStyles(sidebarStyle)(Sidebar));
